<template>
  <div class="about-us-page-container" v-cloak>
    <nav-bar model="blue"></nav-bar>
    <banner></banner>
    <about-us-content></about-us-content>
    <page-footer></page-footer>
  </div>
</template>

<script>
import navBar from "../common/navBar";
import banner from "./components/banner";
import aboutUsContent from "./components/aboutUsContent";
import pageFooter from "../common/pageFooter";
export default {
  components: {
    navBar,
    banner,
    aboutUsContent,
    pageFooter,
  },
  data() {
    return {};
  },
  mounted() {
    new this.$wow.WOW({
      mobile: false,
      live: false,
    }).init();
  },
};
</script>

<style lang="scss" scoped>
.about-us-page-container {
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/aboutUs.vue